import ENTITY_TYPE from "enums/ENTITY_TYPE";
import HTTP_METHOD from "enums/HTTP_METHOD";
import endpoints from "hooks/api/endpoints";
import useApiWrite from "hooks/api/useApiWrite";
import useProject from "hooks/useProject";
import IndividualItemResponse from "types/IndividualItemResponse";
import NoteDto from "types/NoteDto";

export default function useCreateOrUpdateEntityNote(
  entityType?: ENTITY_TYPE,
  entityId?: string,
) {
  const { projectId } = useProject();
  const { write, ...rest } = useApiWrite();

  const createOrUpdateEntityNote = (
    data: NoteDto,
  ): Promise<IndividualItemResponse<NoteDto>> =>
    write<IndividualItemResponse<NoteDto>>({
      url: data.id
        ? endpoints.putEntityNote(projectId, data.id)
        : entityType && entityId
          ? endpoints.postEntityNote(projectId, entityType, entityId)
          : "",
      method: data.id ? HTTP_METHOD.PUT : HTTP_METHOD.POST,
      data,
      mutateOnSuccess:
        entityType && entityId
          ? [endpoints.getEntityNotes(projectId, entityType, entityId)]
          : [],
    }).then(({ data }) => data);

  return { createOrUpdateEntityNote, ...rest };
}
